module.exports = __webpack_public_path__ + "static/media/ob_logo.e718440a.svg";